export default __webpack_public_path__ + "static/media/Sdika.52c04f11.jpeg";